import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { auth } from "config/firebase";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export type EnvironmentKey = "dev" | "uat" | "prod";

const URLs: Record<EnvironmentKey, string> = {
  dev: "https://onlymassage.io/",
  uat: "https://onlymassage.io/",
  prod: "",
};

class AxiosInstance {
  constructor() {
    // @ts-ignore
    this.axios = axios.create({
      baseURL:
        URLs[(publicRuntimeConfig.environment as EnvironmentKey) || "dev"],
    });
  }

  private axios;

  public get = <T = any>(
    ...params: [string, AxiosRequestConfig?]
  ): Promise<AxiosResponse<T>> => this.axios.get<T>(...params);

  public post = <T = any>(
    ...params: [string, any?, AxiosRequestConfig?]
  ): Promise<AxiosResponse<T>> => this.axios.post<T>(...params);

  public delete = <T = any>(
    ...params: [string, AxiosRequestConfig?]
  ): Promise<AxiosResponse<T>> => this.axios.delete<T>(...params);

  public patch = <T = any>(
    ...params: [string, any?, AxiosRequestConfig?]
  ): Promise<AxiosResponse<T>> => this.axios.patch<T>(...params);

  public put = <T = any>(
    ...params: [string, any?, AxiosRequestConfig?]
  ): Promise<AxiosResponse<T>> => this.axios.put<T>(...params);
}

export default AxiosInstance;
